import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Buttons, Spacer, boxContainer, questionnaireComponents } from "..";

import "./styles.css";

const Demographics = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [state, setState] = useState({
    uniHistoryImportance: "",
    studentDiversityImportance: "",
  });

  useEffect(() => {
    setState({
      uniHistoryImportance: questionnaire?.uniHistoryImportance ?? "",
      studentDiversityImportance:
        questionnaire?.studentDiversityImportance ?? "",
    });
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <questionnaireComponents.QuestionnaireLabel
        text="1. How important is it to you that a university has a long and
             established history?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.uniHistoryImportance}
      />
      <Spacer height="1.5em" />
      <questionnaireComponents.QuestionnaireLabel
        text="2. How important is the university's student diversity for you?"
        required
      />
      <Spacer height="0.625em" />
      <questionnaireComponents.QuestionnaireCircleInput
        value={state?.studentDiversityImportance}
      />
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Others")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default Demographics;
